module.exports = __webpack_public_path__ + "static/img/id002.05ab0626.jpg";